// Simple i18n implementation
import { getDefaultLanguage, getBrandName, isHandyHost } from './brand';

export type Language = 'en' | 'ko' | 'id';

export interface Translations {
  // Common
  home: string;
  game: string;
  wallet: string;
  staking: string;
  events: string;
  settings: string;
  cancel: string;
  confirm: string;
  close: string;
  save: string;
  loading: string;
  
  // Auth
  signIn: string;
  createAccount: string;
  username: string;
  usernamePlaceholder: string;
  pin: string;
  pinPlaceholder: string;
  confirmPin: string;
  confirmPinPlaceholder: string;
  phoneNumber: string;
  phoneNumberPlaceholder: string;
  alreadyHaveAccount: string;
  dontHaveAccount: string;
  keepPinSecure: string;
  joinHandyWallet: string;
  welcomeBack: string;
  pleaseEnterBoth: string;
  pleaseEnterAll: string;
  pinMinLength: string;
  pinsDoNotMatch: string;
  loginFailed: string;
  registrationFailed: string;
  
  // Greetings
  goodMorning: string;
  goodAfternoon: string;
  goodEvening: string;
  haveGreatDay: string;
  enjoyYourDay: string;
  haveWonderfulDay: string;
  makeGreatDay: string;
  haveAmazingDay: string;
  haveGreatEvening: string;
  enjoyYourEvening: string;
  haveWonderfulEvening: string;
  makeGreatEvening: string;
  haveAmazingEvening: string;
  
  // Dashboard
  portfolioBalance: string;
  yourBalance: string;
  totalBalance: string;
  totalValue: string;
  recentTransactions: string;
  noTransactions: string;
  referralCode: string;
  memberSince: string;
  walletAddressLabel: string;
  
  // Welcome Bonus
  welcomeBonus: string;
  welcomeBonusAvailable: string;
  getBonus: string;
  enterReferralCode: string;
  tapToEnterReferral: string;
  verify: string;
  invalidReferralCode: string;
  welcomeBonusReceived: string;
  alreadyReceivedBonus: string;
  congratulations: string;
  welcomeToHandy: string;
  bonusCredited: string;
  goToWallet: string;
  welcomeBonusTitle: string;
  registrationComplete: string;
  registrationBonus: string;
  vttnPaid: string;
  recommendToFriend: string;
  bothGetBonus: string;
  getWelcomeBonus: string;
  dontShowAgain: string;
  discoverMoreBenefits: string;
  
  // Boom Event Popup
  boomEventPromoTitle: string;
  boomEventPromoSubtitle: string;
  boomEventPromoDescription: string;
  boomEventPromoCTA: string;
  
  // Wallet
  mainWallet: string;
  send: string;
  receive: string;
  swap: string;
  scan: string;
  cryptoAssets: string;
  nfts: string;
  addToken: string;
  myAssets: string;
  tokens: string;
  usdValue: string;
  transfer: string;
  qrCode: string;
  
  // Staking
  availableBalance: string;
  validatorNode: string;
  premiumStaking: string;
  basicStaking: string;
  subscribeNow: string;
  stakingProducts: string;
  myNodes: string;
  earnRewards: string;
  runValidatorNode: string;
  subscriptionFee: string;
  rewards: string;
  stakingPeriod: string;
  months: string;
  stakeTokens: string;
  startStaking: string;
  minStake: string;
  lockPeriod: string;
  expected: string;
  comingSoon: string;
  higherReturns: string;
  safeStableOption: string;
  details: string;
  reserveNodeFree: string;
  operating: string;
  online: string;
  status: string;
  blocks: string;
  chainId: string;
  version: string;
  basicInformation: string;
  nodeId: string;
  rpcUrl: string;
  currentBlock: string;
  rewardInformation: string;
  dailyRewards: string;
  weeklyRewards: string;
  monthlyRewards: string;
  yearRewards: string;
  hardwareSpecs: string;
  nodeSubscription: string;
  handyFullNode: string;
  productSummary: string;
  premiumValidator: string;
  stakingAmount: string;
  expectedAPY: string;
  nickname: string;
  agreeToTerms: string;
  termsAndConditions: string;
  
  // Events
  participants: string;
  entryFee: string;
  joinBattle: string;
  news: string;
  firstBoomEvent: string;
  handyTournament: string;
  preRegistration: string;
  yourBalance: string;
  startDate: string;
  endDate: string;
  prizePool: string;
  firstPlace: string;
  secondPlace: string;
  thirdPlace: string;
  
  // Rewards
  myReferralCode: string;
  totalEarnings: string;
  referralCount: string;
  shareCode: string;
  manageReferrals: string;
  shareWithFriends: string;
  copyCode: string;
  share: string;
  totalReferrals: string;
  totalEarned: string;
  
  // Settings
  profile: string;
  security: string;
  notifications: string;
  language: string;
  darkMode: string;
  logout: string;
  serverMonitoring: string;
  
  // Languages
  english: string;
  korean: string;
  indonesian: string;
  
  // News Ticker
  boomEventTitle: string;
  boomEventContent: string;
  referralTitle: string;
  referralContent: string;
  nodeTitle: string;
  nodeContent: string;
  
  // Payment
  confirmPayment: string;
  enterPIN: string;
  processingPayment: string;
  paymentSuccessful: string;
  enterPinToConfirm: string;
  pleaseWaitProcessing: string;
  subscriptionActivated: string;
  paymentMethod: string;
  balance: string;
  securityNotice: string;
  secureTransaction: string;
  continue: string;
  back: string;
  confirmPaymentButton: string;
  amountToPay: string;
  payNow: string;
  insufficientBalance: string;
  needMorewHANDY: string;
  
  // Rewards Detail
  assetManagement: string;
  referralTree: string;
  peopleUsedCode: string;
  noReferralsYet: string;
  startSharing: string;
  currentRank: string;
  yourReferralTier: string;
  bronze: string;
  silver: string;
  gold: string;
  progress: string;
  nextTier: string;
  needMoreReferrals: string;
  
  // News & FAQ
  news: string;
  faq: string;
  frequentlyAskedQuestions: string;
  howCanWeHelp: string;
  findAnswers: string;
  handyAI: string;
  quickHelpTopics: string;
  accountSetup: string;
  paymentIssues: string;
  stakingHelp: string;
  security: string;
  howToCreateAccount: string;
  howToAddPayment: string;
  stockMarketOpen: string;
  stockMarketWeekends: string;
  askHandyAI: string;
  announcement: string;
  update: string;
  handyGrandOpening: string;
  grandOpeningDesc: string;
  newStakingProgram: string;
  stakingProgramDesc: string;
  boomEventUltimate: string;
  boomEventDesc: string;
  handyTeam: string;
  defiTeam: string;
  eventsTeam: string;
  minRead: string;
  views: string;
  online: string;
  viewFAQ: string;
  startChatWithHandyAI: string;
  handyAISupport: string;
  getHelpFromAI: string;
  frequentlyAskedQuestionsTitle: string;
  getAnswersToCommon: string;
  
  // News Articles Full Content
  newsArticle1Content: string;
  newsArticle2Content: string;
  newsArticle3Content: string;
  
  // FAQ Questions & Answers
  faqQ1: string;
  faqA1: string;
  faqQ2: string;
  faqA2: string;
  faqQ3: string;
  faqA3: string;
  faqQ4: string;
  faqA4: string;
  faqCategory1: string;
  faqCategory2: string;
  faqCategory3: string;
  
  // AI Chat Responses
  aiWelcomeMessage: string;
  aiAccountResponse: string;
  aiPaymentResponse: string;
  aiStakingResponse: string;
  aiBoomResponse: string;
  aiReferralResponse: string;
  aiSecurityResponse: string;
  aiBalanceResponse: string;
  aiHelloResponse: string;
  aiThanksResponse: string;
  aiDefaultResponse: string;

  // Dashboard banners
  welcomeBannerTitle: string;
  welcomeBannerDesc: string;
  boom2EndedBannerTitle: string;
  boom2EndedBannerDesc: string;
  totalPrizeLabel: string;
  boom1WinnerBannerTitle: string;
  boom1WinnerBannerDesc: string;
  clickToCheckLabel: string;
  checkResultLabel: string;
  loadingUserInfo: string;

  // Event 2 ended notice popup
  event2NoticeTitle: string;
  event2NoticeP1: string;
  event2NoticeP2: string;
  event2NoticeP3: string;
  event2NoticeThanks: string;
  messageHiddenToast: string;

  // Winner check popup
  winnerCheckTitle: string;
  winnerTier1: string;
  winnerTier2: string;
  winnerTier3: string;
  winnerTier4: string;
  winnerTier5: string;
  noParticipatedDesc: string;
  noParticipatedHint: string;
  noParticipatedAction: string;
  winnerResultIntro: string;
  prizeLabel: string;
  winnerPrizeNotice: string;
  notWinnerTitle: string;
  notWinnerDesc: string;
  notWinnerHint: string;
  viewAllWinnersButton: string;
  joinBoom2Button: string;
  authRequired: string;
  loginRequired: string;
  winnerCheckFailed: string;
  winnerCheckError: string;
  walletAddressNotFound: string;
  addressCopied: string;
  addressCopyFailed: string;
  userSuffix: string;

  // Events page
  loadingEvents: string;
  noActiveEvents: string;
  eventDefaultTitle: string;
  eventEndedSuffix: string;
  eventStatusUpcoming: string;
  eventStatusActive: string;
  eventStatusEnded: string;
  eventStartLabel: string;
  eventEndLabel: string;
  totalPrizePoolLabel: string;
  prizeInfoUnavailable: string;
  prizeEachPrefix: string;
  eventDefaultDesc: string;
  eventDescTemplate: string;
  eventPreparing: string;
  eventStartingSoon: string;
  eventEndedButton: string;
  winnerAnnouncementPending: string;
  alreadyParticipated: string;
  joinEventButton: string;
  alreadyJoinedEvent: string;
  checkTransactionHistory: string;
  insufficientEntryFee: string;
  enterReferralGet100: string;
  insufficientBalanceTitle: string;
  insufficientBalanceMessage: string;
  insufficientBalanceHint: string;
  referralModalDesc: string;
  verifying: string;
  checkingParticipationToast: string;
  eventNotStarted: string;
  eventAlreadyEnded: string;
  alreadyParticipatedToast: string;
  enterReferralCodeToast: string;
  invalidReferralCodeToast: string;
  welcomeBonusReceivedToast: string;
  referralProcessingError: string;
  memberDefault: string;
  durationLabel: string;
  durationDays: string;
  boomViewWinnersButton: string;
  event1EndedTitle: string;
  event1EndedBody: string;
  boomEventPromoRemaining: string;
  boomWelcomeBonus100: string;
  boomStartDateLabel: string;
  boomEndDateLabel: string;
  walletTransferTitle: string;
  walletTransferDesc: string;
  transferAmountLabel: string;
  transferFromTo: string;
  noRecentTransactions: string;
  transactionsWillAppear: string;
  transactionCount: string;
  blockLabel: string;
  noRecentReceives: string;
  noRecentSwaps: string;
  transferCompleted: string;
  transferAmountRequired: string;
  selectSenderWallet: string;
  selectReceiverWallet: string;
  enterValidAmount: string;
  insufficientFunds: string;
  transferSuccess: string;
  foundationTransferFailed: string;
  cannotLoadUsers: string;
  senderWallet: string;
  receiverWallet: string;
  foundationWallet: string;
  referralFeeInfo: string;
  referrerBonus: string;
  refereeBonus: string;
  totalReferralReceived: string;
  pinChangeFailed: string;
  enterPinPrompt: string;
  nodeReservationFailed: string;
  nodeReservationSuccess: string;
  stakingSubscribeFailed: string;
}

const translations: Record<Language, Translations> = {
  en: {
    // Common
    home: 'Home',
    game: 'Game',
    wallet: 'Wallet',
    staking: 'Staking',
    events: 'Events',
    settings: 'Settings',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    save: 'Save',
    loading: 'Loading...',
    
    // Auth
    signIn: 'Sign In',
    createAccount: 'Create Account',
    username: 'Username',
    usernamePlaceholder: 'Nickname (2-10 chars) *',
    pin: 'PIN',
    pinPlaceholder: 'Password (6-10 digits) *',
    confirmPin: 'Confirm PIN',
    confirmPinPlaceholder: 'Confirm Password *',
    phoneNumber: 'Phone Number',
    phoneNumberPlaceholder: 'Phone Number *',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    keepPinSecure: 'Keep your PIN secure and never share it with anyone.',
    joinHandyWallet: 'Join Handy Wallet',
    welcomeBack: 'Welcome back!',
    pleaseEnterBoth: 'Please enter both nickname and PIN.',
    pleaseEnterAll: 'Please fill in all required fields.',
    pinMinLength: 'PIN must be at least 6 digits.',
    pinsDoNotMatch: 'PINs do not match.',
    loginFailed: 'Login failed.',
    registrationFailed: 'Registration failed.',
    
    // Greetings
    goodMorning: 'Good morning',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    haveGreatDay: 'Have a great day!',
    enjoyYourDay: 'Enjoy your day!',
    haveWonderfulDay: 'Have a wonderful day!',
    makeGreatDay: 'Make it a great day!',
    haveAmazingDay: 'Have an amazing day!',
    haveGreatEvening: 'Have a great evening!',
    enjoyYourEvening: 'Enjoy your evening!',
    haveWonderfulEvening: 'Have a wonderful evening!',
    makeGreatEvening: 'Make it a great evening!',
    haveAmazingEvening: 'Have an amazing evening!',
    
    // Dashboard
    portfolioBalance: 'Portfolio Balance',
    yourBalance: 'Your Balance',
    totalBalance: 'Total Balance',
    totalValue: 'Total Value',
    recentTransactions: 'Recent Transactions',
    noTransactions: 'No transactions yet',
    referralCode: 'Referral Code',
    memberSince: 'Member since',
    walletAddressLabel: 'Wallet Address',
    
    // Welcome Bonus
    welcomeBonus: 'Welcome Bonus',
    welcomeBonusAvailable: 'Welcome Bonus Available!',
    getBonus: 'Get Bonus',
    enterReferralCode: 'Enter referral code',
    tapToEnterReferral: 'Tap to enter referral code & get 100 wHANDY',
    verify: 'Verify',
    invalidReferralCode: 'Invalid referral code.',
    welcomeBonusReceived: 'Welcome Bonus 100 wHANDY received!',
    alreadyReceivedBonus: 'You have already received the welcome bonus.',
    congratulations: 'Congratulations!',
    welcomeToHandy: 'Welcome to Handy Wallet!',
    bonusCredited: 'Your welcome bonus has been credited',
    goToWallet: 'Go to Wallet',
    welcomeBonusTitle: 'Welcome Bonus',
    registrationComplete: 'Handy Wallet Registration Complete',
    registrationBonus: 'Handy Wallet Registration Bonus',
    vttnPaid: '30 wHANDY has been credited.',
    recommendToFriend: 'Recommend to a friend',
    bothGetBonus: 'You and your friend each get a 100 wHANDY welcome bonus.',
    getWelcomeBonus: 'Get Welcome Bonus',
    dontShowAgain: "Don't show again",
    discoverMoreBenefits: 'Discover more benefits on Handy Wallet!',
    
    // Boom Event Popup
    boomEventPromoTitle: '🔥 2nd BOOM Event is Live!',
    boomEventPromoSubtitle: 'Join the 180,000 wHANDY prize pool tournament.',
    boomEventPromoDescription: 'Grab your 100 wHANDY welcome bonus on the home screen and join the 180,000 wHANDY Boom Event!',
    boomEventPromoCTA: 'Join Boom Event',
    
    // Wallet
    mainWallet: 'Main Wallet',
    send: 'Send',
    receive: 'Receive',
    swap: 'Swap',
    scan: 'Scan',
    cryptoAssets: 'Crypto Assets',
    nfts: 'NFTs',
    addToken: 'Add Token',
    myAssets: 'My Assets',
    tokens: 'tokens',
    usdValue: 'USD Value',
    transfer: 'Trans',
    qrCode: 'QR Code',
    
    // Staking
    availableBalance: 'Available Balance',
    validatorNode: 'Validator Node',
    premiumStaking: 'Premium Staking',
    basicStaking: 'Basic Staking',
    subscribeNow: 'Subscribe Now',
    stakingProducts: 'Staking Products',
    myNodes: 'My Nodes',
    earnRewards: 'Earn rewards by staking your tokens',
    runValidatorNode: 'Run a blockchain validator node',
    subscriptionFee: 'Subscription Fee',
    rewards: 'Rewards',
    stakingPeriod: 'Staking Period',
    months: 'months',
    stakeTokens: 'Stake your wHANDY tokens and earn',
    startStaking: 'Start staking with basic plan and earn',
    minStake: 'Min Stake',
    lockPeriod: 'Lock Period',
    expected: 'Expected',
    comingSoon: 'Coming Soon',
    higherReturns: 'Higher returns for bigger stakes',
    safeStableOption: 'Safe and stable staking option',
    details: 'Details',
    reserveNodeFree: 'Reserve node(free)',
    operating: 'Operating',
    online: 'Online',
    status: 'Status',
    blocks: 'Blocks',
    chainId: 'Chain ID',
    version: 'Version',
    basicInformation: 'Basic Information',
    nodeId: 'Node ID',
    rpcUrl: 'RPC URL',
    currentBlock: 'Current Block',
    rewardInformation: 'Reward Information',
    dailyRewards: 'Daily Rewards',
    weeklyRewards: 'Weekly Rewards',
    monthlyRewards: 'Monthly Rewards',
    yearRewards: 'Year Rewards',
    hardwareSpecs: 'Hardware Specifications',
    nodeSubscription: 'Node Subscription',
    handyFullNode: 'Handy Full Node',
    productSummary: 'Product Summary',
    premiumValidator: 'Premium blockchain validator',
    stakingAmount: 'Staking Amount',
    expectedAPY: 'Expected APY',
    nickname: 'Nickname',
    agreeToTerms: 'I agree to the Terms and Conditions and Service Agreement',
    termsAndConditions: 'Terms and Conditions',
    
    // Events
    participants: 'Participants',
    entryFee: 'Entry Fee',
    joinBattle: 'Join the Battle',
    news: 'News',
    firstBoomEvent: '1st BOOM Event',
    handyTournament: "Handy's first major tournament",
    preRegistration: 'PRE-REGISTRATION',
    yourBalance: 'Your Balance',
    startDate: 'Start Date',
    endDate: 'End Date',
    prizePool: 'Prize Pool',
    firstPlace: '1st Place',
    secondPlace: '2nd Place',
    thirdPlace: '3rd Place',
    
    // Rewards
    myReferralCode: 'My Referral Code',
    totalEarnings: 'Total Earnings',
    referralCount: 'Referral Count',
    shareCode: 'Share Code',
    manageReferrals: 'Manage your referrals and earnings',
    shareWithFriends: 'Share this code with friends',
    copyCode: 'Copy Code',
    share: 'Share',
    totalReferrals: 'Total Referrals (wHANDY)',
    totalEarned: 'Total Earned (wHANDY)',
    
    // Settings
    profile: 'Profile',
    security: 'Security',
    notifications: 'Notifications',
    language: 'Language',
    darkMode: 'Dark Mode',
    logout: 'Logout',
    serverMonitoring: 'Server Monitoring',
    
    // Languages
    english: 'English',
    korean: '한국어',
    indonesian: 'Bahasa Indonesia',
    
    // News Ticker
    boomEventTitle: 'Handy Wallet Grand Opening',
    boomEventContent: 'Join the 1st BOOM Event and win massive rewards!',
    referralTitle: 'Refer Friends & Earn',
    referralContent: 'Invite friends and get 100 wHANDY bonus instantly',
    nodeTitle: 'Handy Mainnet Node Pre-Order',
    nodeContent: 'Amazing benefits! Node product reservation now open',
    
    // Payment
    confirmPayment: 'Confirm Payment',
    enterPIN: 'Enter PIN',
    processingPayment: 'Processing Payment',
    paymentSuccessful: 'Payment Successful',
    enterPinToConfirm: 'Enter your 6-digit PIN to confirm',
    pleaseWaitProcessing: 'Please wait while we process your payment...',
    subscriptionActivated: 'Your subscription has been activated!',
    paymentMethod: 'Payment Method',
    balance: 'Balance',
    securityNotice: 'Security Notice',
    secureTransaction: 'This transaction will be processed securely through our blockchain network.',
    continue: 'Continue',
    back: 'Back',
    confirmPaymentButton: 'Confirm Payment',
    amountToPay: 'Amount to Pay',
    payNow: 'Pay Now',
    insufficientBalance: 'Insufficient Balance',
    needMorewHANDY: 'Need {amount} more wHANDY to join',
    
    // Rewards Detail
    assetManagement: 'Asset Management',
    referralTree: 'Referral Tree',
    peopleUsedCode: 'People who used your code',
    noReferralsYet: 'No referrals yet',
    startSharing: 'Start sharing your code!',
    currentRank: 'Current Rank',
    yourReferralTier: 'Your referral tier',
    bronze: 'Bronze',
    silver: 'Silver',
    gold: 'Gold',
    progress: 'progress',
    nextTier: 'Next',
    needMoreReferrals: 'need {count} more referrals',
    
    // News & FAQ
    news: 'News',
    faq: 'FAQ',
    frequentlyAskedQuestions: 'Frequently Asked Questions',
    howCanWeHelp: 'How can we help you?',
    findAnswers: 'Find answers to common questions',
    handyAI: 'Handy AI',
    quickHelpTopics: 'Quick Help Topics',
    accountSetup: 'Account Setup',
    paymentIssues: 'Payment Issues',
    stakingHelp: 'Staking Help',
    security: 'Security',
    howToCreateAccount: 'How to create an account?',
    howToAddPayment: 'How to add a payment method by this app?',
    stockMarketOpen: 'What Time Does The Stock Market Open?',
    stockMarketWeekends: 'Is The Stock Market Open On Weekends?',
    askHandyAI: 'Ask Handy AI anything...',
    announcement: 'ANNOUNCEMENT',
    update: 'UPDATE',
    handyGrandOpening: 'Handy Wallet Grand Opening Event',
    grandOpeningDesc: 'Join our spectacular launch event with amazing rewards and exclusive benefits for early adopters.',
    newStakingProgram: 'New Staking Rewards Program Launch',
    stakingProgramDesc: 'Introducing our revolutionary staking program with industry-leading APY rates and flexible terms.',
    boomEventUltimate: 'BOOM Event: The Ultimate Competition',
    boomEventDesc: 'Get ready for the most exciting event in Handy history with massive prizes and global participation.',
    handyTeam: 'Handy Team',
    defiTeam: 'DeFi Team',
    eventsTeam: 'Events Team',
    minRead: 'min read',
    views: 'views',
    online: 'Online',
    viewFAQ: 'View FAQ',
    startChatWithHandyAI: 'Start Chat with Handy AI',
    handyAISupport: 'Handy AI Support',
    getHelpFromAI: 'Get help from our AI assistant',
    frequentlyAskedQuestionsTitle: 'Frequently Asked Questions',
    getAnswersToCommon: 'Get answers to common questions',
    
    // News Articles Full Content
    newsArticle1Content: `# Handy Wallet Grand Opening Event\n\nWe're thrilled to announce the grand opening of Handy Wallet, the next-generation cryptocurrency wallet designed for the modern digital economy.\n\n## What's New?\n\n- **Enhanced Security**: Multi-layer security with biometric authentication\n- **DeFi Integration**: Seamless access to decentralized finance protocols\n- **Staking Rewards**: Earn up to 35% APY on your wHANDY holdings\n- **Cross-chain Support**: Support for multiple blockchain networks\n\n## Launch Benefits\n\nAll early adopters who join during our launch week will receive:\n- 100 wHANDY welcome bonus\n- Premium staking access\n- Exclusive event participation rights\n- Priority customer support\n\n## How to Participate\n\n1. Download the Handy Wallet app\n2. Complete registration with referral code\n3. Verify your account\n4. Start earning rewards immediately\n\nDon't miss this opportunity to be part of the Handy ecosystem from day one!`,
    newsArticle2Content: `# New Staking Rewards Program\n\nWe're excited to introduce our new staking rewards program that offers some of the highest yields in the cryptocurrency space.\n\n## Program Highlights\n\n- **Basic Staking**: 15% APY with no lock-up period\n- **Premium Staking**: 25% APY with 30-day lock-up\n- **Validator Node**: 35% APY with professional node operation\n\n## Getting Started\n\nStaking with Handy is simple and secure:\n\n1. Navigate to the Staking section\n2. Choose your preferred staking tier\n3. Confirm your stake amount\n4. Start earning rewards immediately\n\nYour rewards are calculated daily and can be claimed at any time.`,
    newsArticle3Content: `# BOOM Event: The Ultimate Competition\n\nThe first-ever BOOM Event is here! This is your chance to compete with players from around the world for incredible prizes.\n\n## Event Details\n\n- **Entry Fee**: 30 wHANDY\n- **Duration**: 48 hours of intense competition\n- **Prize Pool**: Over 100,000 wHANDY in total rewards\n- **Participants**: Up to 2,000 competitors\n\n## Prize Structure\n\n- **1st Place**: 40,000 wHANDY\n- **2nd-11th Place**: 3,000 wHANDY each\n- **12th-50th Place**: 1,000 wHANDY each\n- **Multiple Winners**: Additional prizes for top performers\n\n## Registration\n\nPre-registration is now open! Secure your spot early to take advantage of special bonuses and preparation time.\n\nThe competition will test your strategy, timing, and knowledge of the Handy ecosystem. Are you ready to prove you're the ultimate Handy champion?`,
    
    // FAQ Questions & Answers
    faqQ1: 'How to create an account?',
    faqA1: 'Open the Handy Wallet app and follow the steps. Choose your nickname, set up a secure PIN, and follow the verification process. You can also use a referral code to get bonus rewards.',
    faqQ2: 'How to add a payment method by this app?',
    faqA2: 'Go to the Wallet section and tap "Add Payment Method". You can connect your bank account, credit card, or other crypto wallets. All payment methods are secured with bank-level encryption.',
    faqQ3: 'What Time Does The Stock Market Open?',
    faqA3: 'The Handy ecosystem operates 24/7, unlike traditional stock markets. However, some features like customer support follow business hours (9 AM - 6 PM UTC). Trading and staking rewards are processed continuously.',
    faqQ4: 'Is The Stock Market Open On Weekends?',
    faqA4: 'Yes! Cryptocurrency markets and the Handy ecosystem operate 24/7, including weekends and holidays. You can trade, stake, and participate in events any time.',
    faqCategory1: 'Getting Started',
    faqCategory2: 'Payment Methods',
    faqCategory3: 'Trading',
    
    // AI Chat Responses
    aiWelcomeMessage: 'Hi {nickname}! I\'m Handy AI. How can I help you today?',
    aiAccountResponse: 'To create an account: 1) Open Handy Wallet app 2) Choose your nickname 3) Set up a secure PIN 4) Follow verification process. You can also use a referral code for bonus rewards!',
    aiPaymentResponse: 'For payment methods: Go to Wallet → Add Payment Method. You can connect bank accounts, credit cards, or crypto wallets. All payments are secured with bank-level encryption.',
    aiStakingResponse: 'Staking options: Basic (15% APY), Premium (25% APY), Validator Node (35% APY). Navigate to Staking section, choose your tier, and start earning immediately!',
    aiBoomResponse: 'BOOM Event: Entry fee is 30 wHANDY, runs for 48 hours. Prizes up to 40,000 wHANDY! Pre-registration gives you early bird advantages. Check Events tab for details.',
    aiReferralResponse: 'Referral program: Share your referral code with friends. You get 100 wHANDY for each successful referral. Find your code in Settings or use the Share feature!',
    aiSecurityResponse: 'Security features: Biometric authentication, PIN protection, multi-layer encryption. Enable 2FA in Settings for maximum security. Never share your PIN or seed phrase!',
    aiBalanceResponse: 'Your current balance is {balance} wHANDY. You can earn more through staking, referrals, events, and airdrops. Check the Dashboard for detailed balance breakdown.',
    aiHelloResponse: 'Hello! I\'m Handy AI, here to help you with any questions about Handy Wallet. You can ask me about accounts, payments, staking, events, or anything else!',
    aiThanksResponse: 'You\'re welcome! Is there anything else I can help you with today?',
    aiDefaultResponse: 'I understand you\'re asking about: {message}. For detailed help, please check our FAQ section or feel free to ask me more specific questions about Handy Wallet features!',

    // Dashboard banners
    welcomeBannerTitle: 'Claim your welcome bonus now!',
    welcomeBannerDesc: 'Enter a referral code to receive 100 wHANDY.',
    boom2EndedBannerTitle: '2nd BOOM Event (Ended)',
    boom2EndedBannerDesc: '6-day tournament for 180,000 wHANDY total prize pool — entry fee 100 wHANDY',
    totalPrizeLabel: 'Total Prize',
    boom1WinnerBannerTitle: '🎉 1st BOOM Event Winners Announced!',
    boom1WinnerBannerDesc: 'Check your winning result',
    clickToCheckLabel: 'Click to',
    checkResultLabel: 'View Result',
    loadingUserInfo: 'Loading user information...',

    // Event 2 ended notice popup
    event2NoticeTitle: '2nd BOOM Event Ended',
    event2NoticeP1: 'The 2nd BOOM Event has been successfully completed.',
    event2NoticeP2: '2nd prize winner announcements and prize distribution for 1st and 2nd events will be announced at the next event start date and paid automatically.',
    event2NoticeP3: '1st event winner lookup is available via the banner on the wallet app home screen. All event prizes can be used according to Handy project policy.',
    event2NoticeThanks: 'Thank you.',
    messageHiddenToast: 'This message will no longer be shown.',

    // Winner check popup
    winnerCheckTitle: '1st BOOM Event Result',
    winnerTier1: '1st Place',
    winnerTier2: '2nd Place',
    winnerTier3: '3rd Place',
    winnerTier4: '4th Place',
    winnerTier5: '5th Place',
    noParticipatedDesc: 'You have not participated in any event yet.',
    noParticipatedHint: 'You can join directly from the event banner on the home screen.',
    noParticipatedAction: 'Join an event and win prizes!',
    winnerResultIntro: 'Here are the results for the event you joined.',
    prizeLabel: 'Prize',
    winnerPrizeNotice: 'Note: Your prize will be distributed after the 2nd BOOM Event ends and can be used according to Handy Foundation policy.',
    notWinnerTitle: 'Unfortunately, you were not selected',
    notWinnerDesc: 'in this event.',
    notWinnerHint: 'We hope to see you in the next event! 🎯',
    viewAllWinnersButton: 'View All 1st BOOM Event Winners',
    joinBoom2Button: 'Join 2nd BOOM Event',
    authRequired: 'Authentication required.',
    loginRequired: 'Login required.',
    winnerCheckFailed: 'Failed to check winning result.',
    winnerCheckError: 'An error occurred while checking the result.',
    walletAddressNotFound: 'Wallet address not found.',
    addressCopied: 'Wallet address copied!',
    addressCopyFailed: 'Failed to copy address.',
    userSuffix: '',

    loadingEvents: 'Loading event information...',
    noActiveEvents: 'No active events at the moment.',
    eventDefaultTitle: 'BOOM Event',
    eventEndedSuffix: ' (Ended)',
    eventStatusUpcoming: 'Upcoming',
    eventStatusActive: 'Active',
    eventStatusEnded: 'Ended',
    eventStartLabel: 'Event Start',
    eventEndLabel: 'Event End',
    totalPrizePoolLabel: 'Total Prize Pool',
    prizeInfoUnavailable: 'Prize information is unavailable.',
    prizeEachPrefix: 'each ',
    eventDefaultDesc: 'Join and win big prizes!',
    eventDescTemplate: 'Participate in the tournament with a total prize pool of {amount} wHANDY.',
    eventPreparing: 'Event Preparing',
    eventStartingSoon: '(Starting soon)',
    eventEndedButton: 'Event Ended',
    winnerAnnouncementPending: '(Winner announcement pending)',
    alreadyParticipated: 'Already Participated',
    joinEventButton: 'Join Event ({fee} wHANDY)',
    alreadyJoinedEvent: 'You have already joined this event.',
    checkTransactionHistory: 'Check payment history in Transaction History.',
    insufficientEntryFee: 'Insufficient entry fee: {fee} wHANDY required.',
    enterReferralGet100: 'Enter referral code to get 100 wHANDY',
    insufficientBalanceTitle: 'Insufficient Entry Fee',
    insufficientBalanceMessage: '{nickname}, you do not have enough entry fee.',
    insufficientBalanceHint: 'Enter a friend\'s referral code to get 100 wHANDY and join the 2nd BOOM Event.',
    referralModalDesc: 'Enter a referral code to receive 100 wHANDY',
    verifying: 'Verifying...',
    checkingParticipationToast: 'Checking participation info. Please wait...',
    eventNotStarted: 'The event has not started yet.',
    eventAlreadyEnded: 'This event has already ended.',
    alreadyParticipatedToast: 'You have already joined this event.',
    enterReferralCodeToast: 'Please enter a referral code.',
    invalidReferralCodeToast: 'Invalid referral code.',
    welcomeBonusReceivedToast: 'Received 100 wHANDY welcome bonus! TX: {tx}...',
    referralProcessingError: 'Error processing referral code.',
    memberDefault: 'Member',
    durationLabel: 'Duration',
    durationDays: '{days} days',
    boomViewWinnersButton: 'View 1st BOOM Event Results',
    event1EndedTitle: '1st BOOM Event Ended',
    event1EndedBody: 'The 1st BOOM Event with 1,420 participants has ended successfully.\n\n1st event results will be announced on November 15 at 4 PM.',
    boomEventPromoRemaining: 'The 2nd BOOM Event ends soon.\nGet your 100 wHANDY welcome bonus on the home screen\nand join the 2nd BOOM Event!',
    boomWelcomeBonus100: 'Get 100 wHANDY Welcome Bonus',
    boomStartDateLabel: 'Start Date',
    boomEndDateLabel: 'End Date',
    walletTransferTitle: 'Wallet Transfer',
    walletTransferDesc: 'Transfer tokens between wallets',
    transferAmountLabel: 'Transfer Amount (wHANDY)',
    transferFromTo: 'Transfer from {from} to {to}',
    noRecentTransactions: 'No recent transactions',
    transactionsWillAppear: 'Transactions will appear here',
    transactionCount: '{count} transactions',
    blockLabel: 'Block',
    noRecentReceives: 'No recent receive history',
    noRecentSwaps: 'No recent swap history',
    transferCompleted: 'Transfer completed successfully.',
    transferAmountRequired: 'Please enter transfer amount.',
    selectSenderWallet: 'Please select sender wallet.',
    selectReceiverWallet: 'Please select receiver wallet.',
    enterValidAmount: 'Please enter a valid amount.',
    insufficientFunds: 'Insufficient balance.',
    transferSuccess: 'Successfully sent {amount} wHANDY to {recipient}.',
    foundationTransferFailed: 'Foundation wallet transfer failed.',
    cannotLoadUsers: 'Cannot load user list.',
    senderWallet: 'Sender Wallet',
    receiverWallet: 'Receiver Wallet',
    foundationWallet: 'Foundation',
    referralFeeInfo: 'Referral fee information',
    referrerBonus: 'Referrer Bonus',
    refereeBonus: 'Referee Bonus',
    totalReferralReceived: 'Total Referrals Received',
    pinChangeFailed: 'Failed to change PIN.',
    enterPinPrompt: 'Enter your PIN:',
    nodeReservationFailed: 'Node reservation failed.',
    nodeReservationSuccess: 'Node reservation completed!\nReservation ID: {id}\nYour node will be created after admin approval.',
    stakingSubscribeFailed: 'Staking subscription failed.',
  },
  ko: {
    // Common
    home: '홈',
    game: '게임',
    wallet: '지갑',
    staking: '스테이킹',
    events: '이벤트',
    settings: '설정',
    cancel: '취소',
    confirm: '확인',
    close: '닫기',
    save: '저장',
    loading: '로딩중...',
    
    // Auth
    signIn: '로그인',
    createAccount: '회원가입',
    username: '사용자명',
    usernamePlaceholder: '닉네임 (2-10자) *',
    pin: 'PIN',
    pinPlaceholder: '비밀번호 (6-10자리) *',
    confirmPin: 'PIN 확인',
    confirmPinPlaceholder: '비밀번호 확인 *',
    phoneNumber: '전화번호',
    phoneNumberPlaceholder: '전화번호 *',
    alreadyHaveAccount: '이미 계정이 있으신가요?',
    dontHaveAccount: '계정이 없으신가요?',
    keepPinSecure: '비밀번호를 안전하게 보관하고 절대 공유하지 마세요.',
    joinHandyWallet: '핸디월렛 가입하기',
    welcomeBack: '다시 오신 것을 환영합니다!',
    pleaseEnterBoth: '사용자명과 PIN을 모두 입력해주세요.',
    pleaseEnterAll: '모든 필수 항목을 입력해주세요.',
    pinMinLength: '비밀번호는 최소 6자리 이상이어야 합니다.',
    pinsDoNotMatch: '비밀번호가 일치하지 않습니다.',
    loginFailed: '로그인에 실패했습니다.',
    registrationFailed: '회원가입에 실패했습니다.',
    
    // Greetings
    goodMorning: '좋은 아침입니다',
    goodAfternoon: '좋은 오후입니다',
    goodEvening: '좋은 저녁입니다',
    haveGreatDay: '즐거운 하루 보내세요!',
    enjoyYourDay: '좋은 하루 되세요!',
    haveWonderfulDay: '멋진 하루 보내세요!',
    makeGreatDay: '오늘도 화이팅!',
    haveAmazingDay: '행복한 하루 되세요!',
    haveGreatEvening: '즐거운 저녁 보내세요!',
    enjoyYourEvening: '좋은 저녁 되세요!',
    haveWonderfulEvening: '멋진 저녁 보내세요!',
    makeGreatEvening: '편안한 저녁 되세요!',
    haveAmazingEvening: '행복한 저녁 되세요!',
    
    // Dashboard
    portfolioBalance: '포트폴리오 잔액',
    yourBalance: '보유 잔액',
    totalBalance: '총 잔액',
    totalValue: '총 가치',
    recentTransactions: '최근 거래',
    noTransactions: '거래 내역이 없습니다',
    referralCode: '추천 코드',
    memberSince: '가입일',
    walletAddressLabel: '지갑 주소',
    
    // Welcome Bonus
    welcomeBonus: '웰컴 보너스',
    welcomeBonusAvailable: '웰컴 보너스를 받을 수 있어요!',
    getBonus: '보너스 받기',
    enterReferralCode: '추천 코드 입력',
    tapToEnterReferral: '추천 코드를 입력하고 100 wHANDY 받기',
    verify: '확인',
    invalidReferralCode: '유효하지 않은 추천 코드입니다.',
    welcomeBonusReceived: '웰컴 보너스 100 wHANDY을 받았습니다!',
    alreadyReceivedBonus: '이미 웰컴 보너스를 받으셨습니다.',
    congratulations: '축하합니다!',
    welcomeToHandy: '핸디월렛에 오신 것을 환영합니다!',
    bonusCredited: '웰컴 보너스가 지급되었습니다',
    goToWallet: '지갑으로 이동',
    welcomeBonusTitle: '웰컴 보너스',
    registrationComplete: '핸디월렛 가입 완료',
    registrationBonus: '핸디월렛 가입 축하금',
    vttnPaid: '30 wHANDY이 지급되었어요.',
    recommendToFriend: '친구에게 추천하세요',
    bothGetBonus: '나도 친구도 웰컴 보너스 100wHANDY을 선물받아요.',
    getWelcomeBonus: '웰컴보너스 받기',
    dontShowAgain: '다시 보지 않기',
    discoverMoreBenefits: '핸디월렛에서 더 많은 혜택을 받아보세요!',
    
    // Boom Event Popup
    boomEventPromoTitle: '🔥 2차 붐 이벤트 진행 중!',
    boomEventPromoSubtitle: '총 상금 180,000 wHANDY 토너먼트',
    boomEventPromoDescription: '앱 첫화면에 웰컴보너스 100wHANDY받아서 총 상금 180,000 wHANDY 붐 이벤트에 참여하세요!',
    boomEventPromoCTA: '붐 이벤트 참여하기',
    
    // Wallet
    mainWallet: '메인 지갑',
    send: '전송',
    receive: '받기',
    swap: '스왑',
    scan: '스캔',
    cryptoAssets: '암호화폐',
    nfts: 'NFT',
    addToken: '토큰 추가',
    myAssets: '보유 자산',
    tokens: '토큰',
    usdValue: 'USD 가치',
    transfer: '전송',
    qrCode: 'QR 코드',
    
    // Staking
    availableBalance: '사용 가능한 잔액',
    validatorNode: '검증자 노드',
    premiumStaking: '프리미엄 스테이킹',
    basicStaking: '기본 스테이킹',
    subscribeNow: '지금 구독하기',
    stakingProducts: '스테이킹 상품',
    myNodes: '내 노드',
    earnRewards: '토큰을 스테이킹하고 보상을 받으세요',
    runValidatorNode: '블록체인 검증자 노드 운영',
    subscriptionFee: '구독료',
    rewards: '보상',
    stakingPeriod: '스테이킹 기간',
    months: '개월',
    stakeTokens: 'wHANDY 토큰을 스테이킹하고 수익을 받으세요',
    startStaking: '기본 플랜으로 스테이킹을 시작하고 수익을 받으세요',
    minStake: '최소 스테이킹',
    lockPeriod: '락업 기간',
    expected: '예상 수익',
    comingSoon: '준비 중',
    higherReturns: '더 큰 스테이킹으로 더 높은 수익',
    safeStableOption: '안전하고 안정적인 스테이킹 옵션',
    details: '상세정보',
    reserveNodeFree: '노드 예약(무료)',
    operating: '운영중',
    online: '온라인',
    status: '상태',
    blocks: '블록',
    chainId: '체인 ID',
    version: '버전',
    basicInformation: '기본 정보',
    nodeId: '노드 ID',
    rpcUrl: 'RPC URL',
    currentBlock: '현재 블록',
    rewardInformation: '보상 정보',
    dailyRewards: '일일 보상',
    weeklyRewards: '주간 보상',
    monthlyRewards: '월간 보상',
    yearRewards: '연간 보상',
    hardwareSpecs: '하드웨어 사양',
    nodeSubscription: '노드 구독',
    handyFullNode: '핸디 풀노드',
    productSummary: '상품 요약',
    premiumValidator: '프리미엄 블록체인 검증자',
    stakingAmount: '스테이킹 수량',
    expectedAPY: '예상 APY',
    nickname: '닉네임',
    agreeToTerms: '약관 및 서비스 계약에 동의합니다',
    termsAndConditions: '약관 및 조건',
    
    // Events
    participants: '참가자',
    entryFee: '참가비',
    joinBattle: '배틀 참가하기',
    news: '뉴스',
    firstBoomEvent: '1회 BOOM 이벤트',
    handyTournament: '핸디의 첫 번째 메이저 토너먼트',
    preRegistration: '사전 등록',
    yourBalance: '보유 잔액',
    startDate: '시작 날짜',
    endDate: '종료 날짜',
    prizePool: '상금',
    firstPlace: '1등',
    secondPlace: '2등',
    thirdPlace: '3등',
    
    // Rewards
    myReferralCode: '내 추천 코드',
    totalEarnings: '총 수익',
    referralCount: '추천 인원',
    shareCode: '코드 공유',
    manageReferrals: '추천인과 수익을 관리하세요',
    shareWithFriends: '친구에게 코드를 공유하세요',
    copyCode: '코드 복사',
    share: '공유',
    totalReferrals: '총 추천 인원 (wHANDY)',
    totalEarned: '총 수익 (wHANDY)',
    
    // Settings
    profile: '프로필',
    security: '보안',
    notifications: '알림',
    language: '언어',
    darkMode: '다크 모드',
    logout: '로그아웃',
    serverMonitoring: '서버 모니터링',
    
    // Languages
    english: 'English',
    korean: '한국어',
    indonesian: 'Bahasa Indonesia',
    
    // News Ticker
    boomEventTitle: '핸디월렛 그랜드 오픈',
    boomEventContent: '1회 붐 이벤트에 참여하고 대박 보상을 받아보세요!',
    referralTitle: '친구 추천하고 보상받기',
    referralContent: '친구를 초대하고 100 wHANDY 보너스를 즉시 받으세요',
    nodeTitle: '핸디 메인넷 노드 사전주문',
    nodeContent: '놀라운 혜택! 노드 상품 예약 신청이 시작되었습니다',
    
    // Payment
    confirmPayment: '결제 확인',
    enterPIN: 'PIN 입력',
    processingPayment: '결제 처리 중',
    paymentSuccessful: '결제 완료',
    enterPinToConfirm: '6자리 PIN을 입력하여 확인하세요',
    pleaseWaitProcessing: '결제를 처리하는 동안 잠시 기다려 주세요...',
    subscriptionActivated: '구독이 활성화되었습니다!',
    paymentMethod: '결제 수단',
    balance: '잔액',
    securityNotice: '보안 알림',
    secureTransaction: '이 거래는 블록체인 네트워크를 통해 안전하게 처리됩니다.',
    continue: '계속',
    back: '뒤로',
    confirmPaymentButton: '결제 확인',
    amountToPay: '결제 금액',
    payNow: '지금 결제',
    insufficientBalance: '잔액 부족',
    needMorewHANDY: '참여하려면 {amount} wHANDY이 더 필요합니다',
    
    // Rewards Detail
    assetManagement: '자산 관리',
    referralTree: '추천인 트리',
    peopleUsedCode: '내 코드를 사용한 사람들',
    noReferralsYet: '아직 추천인이 없습니다',
    startSharing: '코드를 공유하기 시작하세요!',
    currentRank: '현재 등급',
    yourReferralTier: '추천인 등급',
    bronze: '브론즈',
    silver: '실버',
    gold: '골드',
    progress: '진행률',
    nextTier: '다음 등급',
    needMoreReferrals: '{count}명 더 필요',
    
    // News & FAQ
    news: '뉴스',
    faq: '자주 묻는 질문',
    frequentlyAskedQuestions: '자주 묻는 질문',
    howCanWeHelp: '무엇을 도와드릴까요?',
    findAnswers: '일반적인 질문에 대한 답변을 찾아보세요',
    handyAI: '핸디 AI',
    quickHelpTopics: '빠른 도움말',
    accountSetup: '계정 설정',
    paymentIssues: '결제 문제',
    stakingHelp: '스테이킹 도움말',
    security: '보안',
    howToCreateAccount: '계정을 어떻게 만드나요?',
    howToAddPayment: '결제 수단을 어떻게 추가하나요?',
    stockMarketOpen: '주식 시장은 몇 시에 열리나요?',
    stockMarketWeekends: '주식 시장은 주말에도 열리나요?',
    askHandyAI: '핸디 AI에게 무엇이든 물어보세요...',
    announcement: '공지사항',
    update: '업데이트',
    handyGrandOpening: '핸디월렛 그랜드 오픈 이벤트',
    grandOpeningDesc: '놀라운 보상과 얼리어답터 전용 혜택이 있는 화려한 런칭 이벤트에 참여하세요.',
    newStakingProgram: '새로운 스테이킹 보상 프로그램 출시',
    stakingProgramDesc: '업계 최고 수준의 APY와 유연한 조건을 갖춘 혁신적인 스테이킹 프로그램을 소개합니다.',
    boomEventUltimate: 'BOOM 이벤트: 최고의 경쟁',
    boomEventDesc: '핸디 역사상 가장 흥미진진한 이벤트를 준비하세요. 막대한 상금과 글로벌 참여가 기다립니다.',
    handyTeam: '핸디 팀',
    defiTeam: '디파이 팀',
    eventsTeam: '이벤트 팀',
    minRead: '분 읽기',
    views: '조회',
    online: '온라인',
    viewFAQ: 'FAQ 보기',
    startChatWithHandyAI: '핸디 AI와 대화 시작',
    handyAISupport: '핸디 AI 지원',
    getHelpFromAI: 'AI 어시스턴트에게 도움 받기',
    frequentlyAskedQuestionsTitle: '자주 묻는 질문',
    getAnswersToCommon: '일반적인 질문에 대한 답변 얻기',
    
    // News Articles Full Content
    newsArticle1Content: `# 핸디월렛 그랜드 오픈 이벤트\n\n현대 디지털 경제를 위해 설계된 차세대 암호화폐 지갑, 핸디월렛의 그랜드 오픈을 발표하게 되어 기쁩니다.\n\n## 새로운 기능\n\n- **강화된 보안**: 생체 인증을 통한 다층 보안\n- **DeFi 통합**: 탈중앙화 금융 프로토콜에 원활하게 접근\n- **스테이킹 보상**: wHANDY 보유로 최대 35% APY 수익\n- **크로스체인 지원**: 여러 블록체인 네트워크 지원\n\n## 런칭 혜택\n\n런칭 주간에 가입하는 모든 얼리어답터는 다음을 받게 됩니다:\n- 100 wHANDY 웰컴 보너스\n- 프리미엄 스테이킹 접근\n- 독점 이벤트 참여 권한\n- 우선 고객 지원\n\n## 참여 방법\n\n1. 핸디월렛 앱 다운로드\n2. 추천 코드로 회원가입 완료\n3. 계정 인증\n4. 즉시 보상 받기 시작\n\n첫날부터 핸디 생태계의 일부가 될 이 기회를 놓치지 마세요!`,
    newsArticle2Content: `# 새로운 스테이킹 보상 프로그램\n\n암호화폐 업계 최고 수준의 수익률을 제공하는 새로운 스테이킹 보상 프로그램을 소개하게 되어 기쁩니다.\n\n## 프로그램 하이라이트\n\n- **베이직 스테이킹**: 락업 기간 없이 15% APY\n- **프리미엄 스테이킹**: 30일 락업으로 25% APY\n- **밸리데이터 노드**: 전문 노드 운영으로 35% APY\n\n## 시작하기\n\n핸디 스테이킹은 간단하고 안전합니다:\n\n1. 스테이킹 섹션으로 이동\n2. 원하는 스테이킹 등급 선택\n3. 스테이킹 금액 확인\n4. 즉시 보상 받기 시작\n\n보상은 매일 계산되며 언제든지 청구할 수 있습니다.`,
    newsArticle3Content: `# BOOM 이벤트: 최고의 경쟁\n\n첫 번째 BOOM 이벤트가 여기 있습니다! 전 세계 플레이어들과 경쟁하여 놀라운 상금을 받을 기회입니다.\n\n## 이벤트 세부사항\n\n- **참가비**: 30 wHANDY\n- **기간**: 48시간의 치열한 경쟁\n- **상금 풀**: 총 100,000 wHANDY 이상의 보상\n- **참가자**: 최대 2,000명의 경쟁자\n\n## 상금 구조\n\n- **1등**: 40,000 wHANDY\n- **2-11등**: 각 3,000 wHANDY\n- **12-50등**: 각 1,000 wHANDY\n- **다수 우승자**: 상위 성과자를 위한 추가 상금\n\n## 등록\n\n사전 등록이 시작되었습니다! 특별 보너스와 준비 시간을 활용하려면 일찍 자리를 확보하세요.\n\n이 경쟁은 당신의 전략, 타이밍, 그리고 핸디 생태계에 대한 지식을 테스트합니다. 당신이 최고의 핸디 챔피언임을 증명할 준비가 되셨나요?`,
    
    // FAQ Questions & Answers
    faqQ1: '계정을 어떻게 만드나요?',
    faqA1: '핸디월렛 앱을 열고 단계를 따라하세요. 닉네임을 선택하고, 안전한 PIN을 설정하고, 인증 과정을 따르세요. 추천 코드를 사용하여 보너스 보상을 받을 수도 있습니다.',
    faqQ2: '이 앱으로 결제 수단을 어떻게 추가하나요?',
    faqA2: '지갑 섹션으로 이동하여 "결제 수단 추가"를 탭하세요. 은행 계좌, 신용카드 또는 다른 암호화폐 지갑을 연결할 수 있습니다. 모든 결제 수단은 은행 수준의 암호화로 보안이 유지됩니다.',
    faqQ3: '주식 시장은 몇 시에 열리나요?',
    faqA3: '핸디 생태계는 전통적인 주식 시장과 달리 24시간 운영됩니다. 그러나 고객 지원과 같은 일부 기능은 업무 시간(UTC 9 AM - 6 PM)을 따릅니다. 거래 및 스테이킹 보상은 지속적으로 처리됩니다.',
    faqQ4: '주식 시장은 주말에도 열리나요?',
    faqA4: '네! 암호화폐 시장과 핸디 생태계는 주말과 공휴일을 포함하여 24시간 운영됩니다. 언제든지 거래하고, 스테이킹하고, 이벤트에 참여할 수 있습니다.',
    faqCategory1: '시작하기',
    faqCategory2: '결제 수단',
    faqCategory3: '거래',
    
    // AI Chat Responses
    aiWelcomeMessage: '안녕하세요 {nickname}님! 저는 핸디 AI입니다. 오늘 무엇을 도와드릴까요?',
    aiAccountResponse: '계정 만들기: 1) 핸디월렛 앱 열기 2) 닉네임 선택 3) 안전한 PIN 설정 4) 인증 과정 따라하기. 추천 코드를 사용하여 보너스 보상도 받을 수 있습니다!',
    aiPaymentResponse: '결제 수단: 지갑 → 결제 수단 추가로 이동. 은행 계좌, 신용카드 또는 암호화폐 지갑을 연결할 수 있습니다. 모든 결제는 은행 수준의 암호화로 보안이 유지됩니다.',
    aiStakingResponse: '스테이킹 옵션: 베이직 (15% APY), 프리미엄 (25% APY), 밸리데이터 노드 (35% APY). 스테이킹 섹션으로 이동하여 등급을 선택하고 즉시 수익을 받기 시작하세요!',
    aiBoomResponse: 'BOOM 이벤트: 참가비는 30 wHANDY이며, 48시간 동안 진행됩니다. 최대 40,000 wHANDY의 상금! 사전 등록하면 조기 등록 혜택을 받을 수 있습니다. 이벤트 탭에서 자세한 내용을 확인하세요.',
    aiReferralResponse: '추천 프로그램: 친구들과 추천 코드를 공유하세요. 성공적인 추천마다 100 wHANDY을 받습니다. 설정에서 코드를 찾거나 공유 기능을 사용하세요!',
    aiSecurityResponse: '보안 기능: 생체 인증, PIN 보호, 다층 암호화. 최대 보안을 위해 설정에서 2FA를 활성화하세요. PIN이나 시드 문구를 절대 공유하지 마세요!',
    aiBalanceResponse: '현재 잔액은 {balance} wHANDY입니다. 스테이킹, 추천, 이벤트 및 에어드랍을 통해 더 많이 벌 수 있습니다. 대시보드에서 상세한 잔액 내역을 확인하세요.',
    aiHelloResponse: '안녕하세요! 저는 핸디 AI입니다. 핸디월렛에 대한 질문을 도와드리겠습니다. 계정, 결제, 스테이킹, 이벤트 또는 기타 모든 것에 대해 물어보세요!',
    aiThanksResponse: '천만에요! 오늘 도와드릴 다른 것이 있나요?',
    aiDefaultResponse: '다음에 대해 질문하신 것으로 이해합니다: {message}. 자세한 도움이 필요하시면 FAQ 섹션을 확인하거나 핸디월렛 기능에 대해 더 구체적인 질문을 해주세요!',

    // Dashboard banners
    welcomeBannerTitle: '웰컴 보너스를 지금 받으세요!',
    welcomeBannerDesc: '추천코드를 입력하면 100 wHANDY을 받을 수 있어요.',
    boom2EndedBannerTitle: '2차 붐이벤트 (종료)',
    boom2EndedBannerDesc: '총 상금 180,000 wHANDY을 향한 6일간의 토너먼트 - 참가비 100 wHANDY',
    totalPrizeLabel: '총 상금',
    boom1WinnerBannerTitle: '🎉 1차 붐 이벤트 당첨자 발표!',
    boom1WinnerBannerDesc: '내 당첨 결과를 확인하세요',
    clickToCheckLabel: '클릭하여',
    checkResultLabel: '결과 확인',
    loadingUserInfo: '사용자 정보를 불러오는 중입니다...',

    // Event 2 ended notice popup
    event2NoticeTitle: '2차 붐 이벤트 종료 안내',
    event2NoticeP1: '2차 붐 이벤트가 성공적으로 완료되었습니다.',
    event2NoticeP2: '2차 당첨자 발표와 1,2차 당첨자 경품 지급은 다음 이벤트 시작일 발표 및 자동 지급 예정입니다.',
    event2NoticeP3: '1차 이벤트 당첨자 조회는 지갑 앱 메인에 배너로 안내중이며, 모든 이벤트 경품은 핸디 프로젝트의 정책에 따라 사용이 가능합니다.',
    event2NoticeThanks: '감사합니다.',
    messageHiddenToast: '이제 이 메시지가 표시되지 않습니다.',

    // Winner check popup
    winnerCheckTitle: '1차 붐 이벤트 당첨 결과 안내',
    winnerTier1: '1등',
    winnerTier2: '2등',
    winnerTier3: '3등',
    winnerTier4: '4등',
    winnerTier5: '5등',
    noParticipatedDesc: '아직 참여한 이벤트가 없습니다.',
    noParticipatedHint: '홈 화면의 이벤트 배너에서 바로 참여할 수 있습니다.',
    noParticipatedAction: '이벤트에 참여하고 경품을 받아보세요!',
    winnerResultIntro: '이벤트 결과입니다.',
    prizeLabel: '경품',
    winnerPrizeNotice: '안내 : 당첨되신 경품은 2차 붐 이벤트가 종료된후 지급이되며 핸디 재단 정책에 따라 이용이 가능하십니다.',
    notWinnerTitle: '안타깝게도 이번 이벤트에서는',
    notWinnerDesc: '당첨되지 않으셨습니다.',
    notWinnerHint: '다음 이벤트에 많은 참여 부탁드립니다! 🎯',
    viewAllWinnersButton: '1차 붐이벤트 전체 당첨자 보기',
    joinBoom2Button: '2차 붐이벤트 참여하기',
    authRequired: '인증이 필요합니다.',
    loginRequired: '로그인이 필요합니다.',
    winnerCheckFailed: '당첨 결과 조회에 실패했습니다.',
    winnerCheckError: '당첨 결과 조회 중 오류가 발생했습니다.',
    walletAddressNotFound: '지갑 주소를 찾을 수 없습니다.',
    addressCopied: '지갑 주소가 복사되었습니다!',
    addressCopyFailed: '주소 복사에 실패했습니다.',
    userSuffix: '님',

    loadingEvents: '이벤트 정보를 불러오는 중입니다...',
    noActiveEvents: '현재 진행 중인 이벤트가 없습니다.',
    eventDefaultTitle: 'BOOM 이벤트',
    eventEndedSuffix: '(종료)',
    eventStatusUpcoming: '준비중',
    eventStatusActive: '진행중',
    eventStatusEnded: '종료',
    eventStartLabel: '이벤트 시작',
    eventEndLabel: '이벤트 종료',
    totalPrizePoolLabel: '총 상금',
    prizeInfoUnavailable: '상금 정보가 없습니다.',
    prizeEachPrefix: '각 ',
    eventDefaultDesc: '참여하고 큰 상금을 획득하세요!',
    eventDescTemplate: '총 상금 {amount} wHANDY 토너먼트에 참여하세요.',
    eventPreparing: '이벤트 준비중',
    eventStartingSoon: '(곧 시작됩니다)',
    eventEndedButton: '이벤트 종료',
    winnerAnnouncementPending: '(당첨자 발표예정)',
    alreadyParticipated: '이미 참여함',
    joinEventButton: '이벤트 참여하기 ({fee} wHANDY)',
    alreadyJoinedEvent: '이미 참가한 이벤트입니다.',
    checkTransactionHistory: '결제 내역은 Transaction History에서 확인할 수 있습니다.',
    insufficientEntryFee: '이벤트 참가비 {fee} wHANDY이 부족합니다.',
    enterReferralGet100: '친구 추천코드 입력 100wHANDY 받기',
    insufficientBalanceTitle: '참가비 부족 안내',
    insufficientBalanceMessage: '{nickname}님, 참가비가 부족합니다.',
    insufficientBalanceHint: '친구의 추천코드를 입력하고 100wHANDY을 받아서 2차 붐 이벤트에 참여하세요.',
    referralModalDesc: '추천코드를 입력하고 100 wHANDY을 받으세요',
    verifying: '인증 중...',
    checkingParticipationToast: '참여 정보 확인 중입니다. 잠시만 기다려 주세요.',
    eventNotStarted: '이벤트 시작 전입니다.',
    eventAlreadyEnded: '이미 종료된 이벤트입니다.',
    alreadyParticipatedToast: '이미 참여한 이벤트입니다.',
    enterReferralCodeToast: '추천코드를 입력해주세요.',
    invalidReferralCodeToast: '유효하지 않은 추천코드입니다.',
    welcomeBonusReceivedToast: '100 wHANDY 웰컴보너스를 받았습니다! TX: {tx}...',
    referralProcessingError: '추천코드 처리 중 오류가 발생했습니다.',
    memberDefault: '회원',
    durationLabel: '기간',
    durationDays: '{days}일간',
    boomViewWinnersButton: '1차 붐이벤트 당첨결과 보기',
    event1EndedTitle: '1차 붐 이벤트 종료안내',
    event1EndedBody: '총 1,420명이 참여한 1차 붐 이벤트가\n성황리에 종료되었습니다.\n\n1차 이벤트 결과는 11월15일 오후에\n발표 예정입니다.',
    boomEventPromoRemaining: '2차 붐이벤트가 하루남았습니다.\n핸디 지갑앱 첫 화면에서 웰컴보너스 100wHANDY 받고,\n2차 붐 이벤트에 참여하세요!',
    boomWelcomeBonus100: '100wHANDY 웰컴보너스 받기',
    boomStartDateLabel: '시작일',
    boomEndDateLabel: '종료일',
    walletTransferTitle: '월렛 트랜스퍼',
    walletTransferDesc: '지갑 간 토큰 전송',
    transferAmountLabel: '전송 금액 (wHANDY)',
    transferFromTo: '{from}에서 {to}으로 전송',
    noRecentTransactions: '최근 트랜잭션이 없습니다',
    transactionsWillAppear: '트랜잭션이 여기에 표시됩니다',
    transactionCount: '거래 {count}건',
    blockLabel: '블록',
    noRecentReceives: '최근 수신 내역이 없습니다',
    noRecentSwaps: '최근 스왑 내역이 없습니다',
    transferCompleted: '전송이 완료되었습니다.',
    transferAmountRequired: '전송할 금액을 입력해주세요.',
    selectSenderWallet: '보내는 지갑을 선택해주세요.',
    selectReceiverWallet: '받는 지갑을 선택해주세요.',
    enterValidAmount: '올바른 금액을 입력해주세요.',
    insufficientFunds: '잔고가 부족합니다.',
    transferSuccess: '{recipient}에게 {amount} wHANDY을 성공적으로 전송했습니다.',
    foundationTransferFailed: '재단 지갑 전송에 실패했습니다.',
    cannotLoadUsers: '유저 목록을 불러올 수 없습니다.',
    senderWallet: '보내는 지갑',
    receiverWallet: '받는 지갑',
    foundationWallet: '재단',
    referralFeeInfo: '추천 수수료 정보',
    referrerBonus: '추천인 보너스',
    refereeBonus: '피추천인 보너스',
    totalReferralReceived: '총받은 레퍼럴',
    pinChangeFailed: 'PIN 변경에 실패했습니다.',
    enterPinPrompt: 'PIN을 입력하세요:',
    nodeReservationFailed: '노드 예약 실패',
    nodeReservationSuccess: '노드 예약이 완료되었습니다!\n예약 ID: {id}\n관리자 승인 후 노드가 생성됩니다.',
    stakingSubscribeFailed: '스테이킹 구독 실패',
  },
  id: {
    // Common
    home: 'Beranda',
    game: 'Game',
    wallet: 'Dompet',
    staking: 'Staking',
    events: 'Acara',
    settings: 'Pengaturan',
    cancel: 'Batal',
    confirm: 'Konfirmasi',
    close: 'Tutup',
    save: 'Simpan',
    loading: 'Memuat...',
    
    // Auth
    signIn: 'Masuk',
    createAccount: 'Buat Akun',
    username: 'Nama Pengguna',
    usernamePlaceholder: 'Nama Panggilan (2-10 karakter) *',
    pin: 'PIN',
    pinPlaceholder: 'Kata Sandi (6-10 digit) *',
    confirmPin: 'Konfirmasi PIN',
    confirmPinPlaceholder: 'Konfirmasi Kata Sandi *',
    phoneNumber: 'Nomor Telepon',
    phoneNumberPlaceholder: 'Nomor Telepon *',
    alreadyHaveAccount: 'Sudah punya akun?',
    dontHaveAccount: 'Belum punya akun?',
    keepPinSecure: 'Jaga PIN Anda tetap aman dan jangan bagikan kepada siapa pun.',
    joinHandyWallet: 'Bergabung dengan Handy Wallet',
    welcomeBack: 'Selamat datang kembali!',
    pleaseEnterBoth: 'Masukkan nama pengguna dan PIN.',
    pleaseEnterAll: 'Isi semua bidang yang diperlukan.',
    pinMinLength: 'PIN minimal 6 digit.',
    pinsDoNotMatch: 'PIN tidak cocok.',
    loginFailed: 'Login gagal.',
    registrationFailed: 'Pendaftaran gagal.',
    
    // Greetings
    goodMorning: 'Selamat pagi',
    goodAfternoon: 'Selamat siang',
    goodEvening: 'Selamat malam',
    haveGreatDay: 'Semoga harimu menyenangkan!',
    enjoyYourDay: 'Nikmati harimu!',
    haveWonderfulDay: 'Semoga harimu luar biasa!',
    makeGreatDay: 'Buat hari ini hebat!',
    haveAmazingDay: 'Semoga harimu menakjubkan!',
    haveGreatEvening: 'Semoga malammu menyenangkan!',
    enjoyYourEvening: 'Nikmati malammu!',
    haveWonderfulEvening: 'Semoga malammu luar biasa!',
    makeGreatEvening: 'Buat malam ini hebat!',
    haveAmazingEvening: 'Semoga malammu menakjubkan!',
    
    // Dashboard
    portfolioBalance: 'Saldo Portfolio',
    yourBalance: 'Saldo Anda',
    totalBalance: 'Total Saldo',
    totalValue: 'Total Nilai',
    recentTransactions: 'Transaksi Terbaru',
    noTransactions: 'Belum ada transaksi',
    referralCode: 'Kode Referral',
    memberSince: 'Anggota sejak',
    walletAddressLabel: 'Alamat Dompet',
    
    // Welcome Bonus
    welcomeBonus: 'Bonus Selamat Datang',
    welcomeBonusAvailable: 'Bonus Selamat Datang Tersedia!',
    getBonus: 'Dapatkan Bonus',
    enterReferralCode: 'Masukkan kode referral',
    tapToEnterReferral: 'Ketuk untuk memasukkan kode referral & dapatkan 100 wHANDY',
    verify: 'Verifikasi',
    invalidReferralCode: 'Kode referral tidak valid.',
    welcomeBonusReceived: 'Bonus Selamat Datang 100 wHANDY diterima!',
    alreadyReceivedBonus: 'Anda sudah menerima bonus selamat datang.',
    congratulations: 'Selamat!',
    welcomeToHandy: 'Selamat datang di Handy Wallet!',
    bonusCredited: 'Bonus selamat datang Anda telah dikreditkan',
    goToWallet: 'Ke Dompet',
    welcomeBonusTitle: 'Bonus Selamat Datang',
    registrationComplete: 'Pendaftaran Handy Wallet Selesai',
    registrationBonus: 'Bonus Pendaftaran Handy Wallet',
    vttnPaid: '30 wHANDY telah dibayarkan.',
    recommendToFriend: 'Rekomendasikan ke teman',
    bothGetBonus: 'Saya dan teman mendapat bonus 100wHANDY.',
    getWelcomeBonus: 'Dapatkan Bonus Selamat Datang',
    dontShowAgain: 'Jangan tampilkan lagi',
    discoverMoreBenefits: 'Temukan lebih banyak manfaat di Handy Wallet!',
    
    // Boom Event Popup
    boomEventPromoTitle: '2차 붐 이벤트 진행 중!',
    boomEventPromoSubtitle: 'Join the 180,000 wHANDY prize pool tournament.',
    boomEventPromoDescription: 'Grab your 100 wHANDY welcome bonus on the home screen and join the 180,000 wHANDY Boom Event!',
    boomEventPromoCTA: 'Join Boom Event',
    
    // Wallet
    mainWallet: 'Dompet Utama',
    send: 'Kirim',
    receive: 'Terima',
    swap: 'Tukar',
    scan: 'Pindai',
    cryptoAssets: 'Aset Kripto',
    nfts: 'NFT',
    addToken: 'Tambah Token',
    
    // Staking
    availableBalance: 'Saldo Tersedia',
    validatorNode: 'Node Validator',
    premiumStaking: 'Staking Premium',
    basicStaking: 'Staking Dasar',
    subscribeNow: 'Berlangganan Sekarang',
    
    // Events
    participants: 'Peserta',
    entryFee: 'Biaya Masuk',
    joinBattle: 'Ikut Pertempuran',
    
    // Rewards
    myReferralCode: 'Kode Referral Saya',
    totalEarnings: 'Total Penghasilan',
    referralCount: 'Jumlah Referral',
    shareCode: 'Bagikan Kode',
    
    // Settings
    profile: 'Profil',
    security: 'Keamanan',
    notifications: 'Notifikasi',
    language: 'Bahasa',
    darkMode: 'Mode Gelap',
    logout: 'Keluar',
    serverMonitoring: 'Monitoring Server',
    
    // Languages
    english: 'English',
    korean: '한국어',
    indonesian: 'Bahasa Indonesia',
    
    // News Ticker
    boomEventTitle: 'Pembukaan Besar Handy Wallet',
    boomEventContent: 'Ikuti BOOM Event ke-1 dan menangkan hadiah besar!',
    referralTitle: 'Ajak Teman & Dapatkan Bonus',
    referralContent: 'Undang teman dan dapatkan bonus 100 wHANDY secara instan',
    nodeTitle: 'Pre-Order Node Mainnet Handy',
    nodeContent: 'Manfaat luar biasa! Reservasi produk node sudah dibuka',

    // Dashboard banners
    welcomeBannerTitle: 'Klaim bonus selamat datang sekarang!',
    welcomeBannerDesc: 'Masukkan kode referral untuk menerima 100 wHANDY.',
    boom2EndedBannerTitle: 'BOOM Event ke-2 (Berakhir)',
    boom2EndedBannerDesc: 'Turnamen 6 hari untuk total hadiah 180.000 wHANDY — biaya masuk 100 wHANDY',
    totalPrizeLabel: 'Total Hadiah',
    boom1WinnerBannerTitle: '🎉 Pemenang BOOM Event ke-1 Diumumkan!',
    boom1WinnerBannerDesc: 'Periksa hasil kemenangan Anda',
    clickToCheckLabel: 'Klik untuk',
    checkResultLabel: 'Lihat Hasil',
    loadingUserInfo: 'Memuat informasi pengguna...',

    event2NoticeTitle: 'BOOM Event ke-2 Berakhir',
    event2NoticeP1: 'BOOM Event ke-2 telah berhasil diselesaikan.',
    event2NoticeP2: 'Pengumuman pemenang ke-2 dan distribusi hadiah untuk event ke-1 dan ke-2 akan diumumkan pada tanggal mulai event berikutnya dan dibayarkan secara otomatis.',
    event2NoticeP3: 'Pencarian pemenang event ke-1 tersedia melalui banner di halaman utama aplikasi dompet. Semua hadiah event dapat digunakan sesuai kebijakan proyek Handy.',
    event2NoticeThanks: 'Terima kasih.',
    messageHiddenToast: 'Pesan ini tidak akan ditampilkan lagi.',

    winnerCheckTitle: 'Hasil BOOM Event ke-1',
    winnerTier1: 'Juara 1',
    winnerTier2: 'Juara 2',
    winnerTier3: 'Juara 3',
    winnerTier4: 'Juara 4',
    winnerTier5: 'Juara 5',
    noParticipatedDesc: 'Anda belum berpartisipasi dalam event apa pun.',
    noParticipatedHint: 'Anda dapat bergabung langsung dari banner event di layar utama.',
    noParticipatedAction: 'Ikuti event dan menangkan hadiah!',
    winnerResultIntro: 'Berikut hasil event yang Anda ikuti.',
    prizeLabel: 'Hadiah',
    winnerPrizeNotice: 'Catatan: Hadiah Anda akan didistribusikan setelah BOOM Event ke-2 berakhir dan dapat digunakan sesuai kebijakan Handy Foundation.',
    notWinnerTitle: 'Sayangnya, Anda tidak terpilih',
    notWinnerDesc: 'dalam event ini.',
    notWinnerHint: 'Kami berharap melihat Anda di event berikutnya! 🎯',
    viewAllWinnersButton: 'Lihat Semua Pemenang BOOM Event ke-1',
    joinBoom2Button: 'Ikuti BOOM Event ke-2',
    authRequired: 'Autentikasi diperlukan.',
    loginRequired: 'Login diperlukan.',
    winnerCheckFailed: 'Gagal memeriksa hasil kemenangan.',
    winnerCheckError: 'Terjadi kesalahan saat memeriksa hasil.',
    walletAddressNotFound: 'Alamat dompet tidak ditemukan.',
    addressCopied: 'Alamat dompet disalin!',
    addressCopyFailed: 'Gagal menyalin alamat.',
    userSuffix: '',

    loadingEvents: 'Memuat informasi acara...',
    noActiveEvents: 'Tidak ada acara aktif saat ini.',
    eventDefaultTitle: 'BOOM Event',
    eventEndedSuffix: ' (Berakhir)',
    eventStatusUpcoming: 'Segera',
    eventStatusActive: 'Aktif',
    eventStatusEnded: 'Berakhir',
    eventStartLabel: 'Mulai Acara',
    eventEndLabel: 'Akhir Acara',
    totalPrizePoolLabel: 'Total Hadiah',
    prizeInfoUnavailable: 'Informasi hadiah tidak tersedia.',
    prizeEachPrefix: 'masing-masing ',
    eventDefaultDesc: 'Ikuti dan menangkan hadiah besar!',
    eventDescTemplate: 'Ikuti turnamen dengan total hadiah {amount} wHANDY.',
    eventPreparing: 'Acara Dipersiapkan',
    eventStartingSoon: '(Segera dimulai)',
    eventEndedButton: 'Acara Berakhir',
    winnerAnnouncementPending: '(Pengumuman pemenang menunggu)',
    alreadyParticipated: 'Sudah Berpartisipasi',
    joinEventButton: 'Ikuti Acara ({fee} wHANDY)',
    alreadyJoinedEvent: 'Anda sudah bergabung dengan acara ini.',
    checkTransactionHistory: 'Periksa riwayat pembayaran di Transaction History.',
    insufficientEntryFee: 'Biaya masuk tidak cukup: {fee} wHANDY diperlukan.',
    enterReferralGet100: 'Masukkan kode referral untuk mendapat 100 wHANDY',
    insufficientBalanceTitle: 'Biaya Masuk Tidak Cukup',
    insufficientBalanceMessage: '{nickname}, biaya masuk Anda tidak cukup.',
    insufficientBalanceHint: 'Masukkan kode referral teman untuk mendapat 100 wHANDY dan ikuti BOOM Event ke-2.',
    referralModalDesc: 'Masukkan kode referral untuk menerima 100 wHANDY',
    verifying: 'Memverifikasi...',
    checkingParticipationToast: 'Memeriksa info partisipasi. Harap tunggu...',
    eventNotStarted: 'Acara belum dimulai.',
    eventAlreadyEnded: 'Acara ini sudah berakhir.',
    alreadyParticipatedToast: 'Anda sudah bergabung dengan acara ini.',
    enterReferralCodeToast: 'Silakan masukkan kode referral.',
    invalidReferralCodeToast: 'Kode referral tidak valid.',
    welcomeBonusReceivedToast: 'Menerima bonus selamat datang 100 wHANDY! TX: {tx}...',
    referralProcessingError: 'Kesalahan memproses kode referral.',
    memberDefault: 'Anggota',
    durationLabel: 'Durasi',
    durationDays: '{days} hari',
    boomViewWinnersButton: 'Lihat Hasil BOOM Event ke-1',
    event1EndedTitle: 'BOOM Event ke-1 Berakhir',
    event1EndedBody: 'BOOM Event ke-1 dengan 1.420 peserta telah berhasil berakhir.\n\nHasil acara ke-1 akan diumumkan pada 15 November pukul 16:00.',
    boomEventPromoRemaining: 'BOOM Event ke-2 segera berakhir.\nDapatkan bonus selamat datang 100 wHANDY di layar utama\ndan ikuti BOOM Event ke-2!',
    boomWelcomeBonus100: 'Dapatkan Bonus Selamat Datang 100 wHANDY',
    boomStartDateLabel: 'Tanggal Mulai',
    boomEndDateLabel: 'Tanggal Berakhir',
    walletTransferTitle: 'Transfer Dompet',
    walletTransferDesc: 'Transfer token antar dompet',
    transferAmountLabel: 'Jumlah Transfer (wHANDY)',
    transferFromTo: 'Transfer dari {from} ke {to}',
    noRecentTransactions: 'Tidak ada transaksi terbaru',
    transactionsWillAppear: 'Transaksi akan muncul di sini',
    transactionCount: '{count} transaksi',
    blockLabel: 'Blok',
    noRecentReceives: 'Tidak ada riwayat penerimaan terbaru',
    noRecentSwaps: 'Tidak ada riwayat swap terbaru',
    transferCompleted: 'Transfer berhasil diselesaikan.',
    transferAmountRequired: 'Silakan masukkan jumlah transfer.',
    selectSenderWallet: 'Silakan pilih dompet pengirim.',
    selectReceiverWallet: 'Silakan pilih dompet penerima.',
    enterValidAmount: 'Silakan masukkan jumlah yang valid.',
    insufficientFunds: 'Saldo tidak cukup.',
    transferSuccess: 'Berhasil mengirim {amount} wHANDY ke {recipient}.',
    foundationTransferFailed: 'Transfer dompet foundation gagal.',
    cannotLoadUsers: 'Tidak dapat memuat daftar pengguna.',
    senderWallet: 'Dompet Pengirim',
    receiverWallet: 'Dompet Penerima',
    foundationWallet: 'Foundation',
    referralFeeInfo: 'Informasi biaya referral',
    referrerBonus: 'Bonus Referrer',
    refereeBonus: 'Bonus Referee',
    totalReferralReceived: 'Total Referral Diterima',
    pinChangeFailed: 'Gagal mengubah PIN.',
    enterPinPrompt: 'Masukkan PIN Anda:',
    nodeReservationFailed: 'Reservasi node gagal.',
    nodeReservationSuccess: 'Reservasi node selesai!\nID Reservasi: {id}\nNode akan dibuat setelah persetujuan admin.',
    stakingSubscribeFailed: 'Langganan staking gagal.',
  }
};

class I18n {
  private currentLanguage: Language;

  constructor() {
    let savedLang = localStorage.getItem('handy-language') as Language;

    /**
     * 기본 언어는 한국어다. 유저가 «직접» 바꾼 경우에만 그 값을 따른다.
     *
     * [2026-10-22] 예전에 isHandyHost() 면 무조건 'en' 을 저장하던 시절이 있었고,
     * 그 값이 폰에 남아 있어 한국 사용자도 계속 영어 메뉴를 봤다.
     * 직접 고른 적이 없으면(handy-lang-user-set 없음) 저장값을 버리고 한국어로 돌린다.
     */
    /**
     * [2026-10-22] 한 번만 전부 한국어로 되돌린다.
     * 반년 가까이 영어로 떠 있었고, 그 사이 '직접 고름' 표시까지 붙은 폰이 많다.
     * 그 표시를 지우고 기본값으로 리셋한 뒤, 이 마커를 남겨 다시는 건드리지 않는다.
     * 리셋 뒤에 유저가 고른 언어는 그대로 유지된다.
     */
    const RESET_KEY = 'handy-lang-reset-20261022';
    if (!localStorage.getItem(RESET_KEY)) {
      localStorage.removeItem('handy-lang-user-set');
      localStorage.setItem('handy-language', getDefaultLanguage());
      localStorage.setItem(RESET_KEY, '1');
    }

    savedLang = localStorage.getItem('handy-language') as Language;
    const userPicked = localStorage.getItem('handy-lang-user-set') === '1';
    if (savedLang && !userPicked && savedLang !== getDefaultLanguage()) {
      this.currentLanguage = getDefaultLanguage();
      localStorage.setItem('handy-language', this.currentLanguage);
    } else if (savedLang && ['en', 'ko', 'id'].includes(savedLang)) {
      this.currentLanguage = savedLang;
    } else {
      this.currentLanguage = getDefaultLanguage();
      localStorage.setItem('handy-language', this.currentLanguage);
    }
  }

  setLanguage(lang: Language) {
    this.currentLanguage = lang;
    localStorage.setItem('handy-language', lang);
    // 호스트와 무관하게 '직접 골랐다' 로 남긴다 — 안 그러면 다음 접속에 되돌아간다
    localStorage.setItem('handy-lang-user-set', '1');
  }

  getCurrentLanguage(): Language {
    return this.currentLanguage;
  }

  t(key: keyof Translations): string {
    return translations[this.currentLanguage][key] || translations.en[key] || key;
  }
}

export const i18n = new I18n();

/** Brand-aware translation (Handy ↔ Handy) */
export function tb(key: keyof Translations): string {
  const brand = getBrandName();
  return i18n
    .t(key)
    .replace(/Handy/g, brand)
    .replace(/핸디/g, brand);
}